import type { ReactNode } from "react";

export interface IInfoAreaProps {
  headLine: ReactNode;
  description: string | ReactNode;
  hasShadow?: boolean;
  hasBorder?: boolean;
  fullWidth?: boolean;
  className?: string;
  classNames?: {
    description?: string;
    container?: string;
  };
}

const InfoArea: React.FC<IInfoAreaProps> = ({
  headLine,
  description,
  hasBorder = false,
  hasShadow = false,
  fullWidth = true,
  className = "",
  classNames,
}) => {
  const base = "mx-auto rounded-2xl bg-primary-darker py-10 px-3 hover-scale ";
  const width = fullWidth ? " w-full " : " !max-w-[min(900px,90%)] ";
  const border = hasBorder ? " border border-primary-lighter " : "";
  const shadow = hasShadow ? " shadow-default " : "";

  return (
    <div
      className={`mx-auto sm:max-w-[min(1500px,90%)] ${classNames?.container}`}
    >
      <div className={`${base} ${width} ${border} ${shadow} ${className}`}>
        <div className={`pb-4 xl:pb-5 ${hasBorder && " pb-2"}`}>{headLine}</div>
        <div
          className={`font-inter font-light text-primary-dark-text text-sm leading-6 ${classNames?.description}`}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default InfoArea;
